import React from "react";
import { passwordRuleChecks } from "../../helpers/passwordPolicy";

/** The password rules, each green once the typed password meets it (same look as the old list: text-muted / text-success). */
export default function PasswordRuleList({ policy, password }) {
  return (
    <ul className="list-unstyled mt-3 mb-1" aria-label="Password rules">
      {passwordRuleChecks(policy, password).map((r) => (
        <li key={r.key} className={`mb-1 ${r.met ? "text-success" : "text-muted"}`} data-met={r.met}>
          <i className={r.met ? "fas fa-check-circle" : "far fa-circle"} aria-hidden="true" /> {r.text}
        </li>
      ))}
    </ul>
  );
}
